import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import FolderSearch from '../folder-search';

import {
  Button,
  ButtonInverted,
  ContainerButton,
  ContainerDropdown,
  Content,
  Dialog,
  Text,
  Title,
  WarningMessage,
  ContainerFolder,
} from './styles';
import CompaniesDropdown from '../companies-dropdown';

const MoveToDialog = (props) => {
  const {
    show,
    handleClose,
    project,
    onMoveProject,
    loadingMoveTo,
    companyId: currentCompanyId,
    projectDependency,
    errorMoveTo,
  } = props;

  const {
    name: projectName,
    id: projectId,
    folder,
  } = project;

  const folderId = _.get(folder, 'id', '');

  const [companyId, setCompanyId] = useState(currentCompanyId);
  const [selectedFolder, setSelectedFolder] = useState(folderId);

  const isSameCompany = useMemo(() => (
    companyId === currentCompanyId
  ), [companyId, currentCompanyId]);

  const {
    hasHighlightReelDependency,
    hasTagHighlightDependency,
  } = projectDependency;

  const handleCloseModal = (e) => {
    setCompanyId(currentCompanyId);
    setSelectedFolder(folderId);
    handleClose(e);
  };

  const handleMove = async () => {
    await onMoveProject(projectId, companyId, selectedFolder);
    setCompanyId(currentCompanyId);
  };
  /**
   * FIXME ADD COMPANY OPTIONS WHICH IS COMPANY LIST
   */

  return (
    <Dialog
      open={show}
      closeOnEscape
      onClose={handleCloseModal}
    >
      <Content>
        <Title>{`Move ${projectName} to`}</Title>

        <ContainerDropdown>
          <Text>Workspace </Text>
          <div style={{ width: '380px' }}>
            <CompaniesDropdown
              setCompanyId={setCompanyId}
            />
          </div>
        </ContainerDropdown>

        <ContainerFolder>
          <FolderSearch
            companyId={companyId}
            handleChange={setSelectedFolder}
            selectedFolder={selectedFolder}
            project={project}
          />
        </ContainerFolder>

        {errorMoveTo && (
          <WarningMessage>
            Something went wrong while moving the project.
          </WarningMessage>
        )}

        {hasHighlightReelDependency && !isSameCompany && (
          <WarningMessage>
            This project contains clips that are a part of an existing highlight reel.
            If you move this project to a new workspace, those clips will be removed
            from all highlight reels in the current workspace.
          </WarningMessage>
        )}

        {hasTagHighlightDependency && !isSameCompany && (
          <WarningMessage>
            This project contains tags & reactions. If you move this project,
            the tags & reactions will be deleted.
          </WarningMessage>
        )}

        <ContainerButton>
          <ButtonInverted
            onClick={handleCloseModal}
            disabled={loadingMoveTo}
          >
            Cancel
          </ButtonInverted>
          <Button
            onClick={handleMove}
            loading={loadingMoveTo}
          >
            Move
          </Button>
        </ContainerButton>
      </Content>
    </Dialog>
  );
};

MoveToDialog.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  name: PropTypes.string,
  project: PropTypes.oneOfType([PropTypes.object]).isRequired,
  onMoveProject: PropTypes.func.isRequired,
  loadingMoveTo: PropTypes.bool.isRequired,
  companyId: PropTypes.string.isRequired,
  projectDependency: PropTypes.shape({
    hasHighlightReelDependency: PropTypes.bool,
    hasTagHighlightDependency: PropTypes.bool,
  }),
  folder: PropTypes.shape({
    id: PropTypes.string,
  }),
  errorMoveTo: PropTypes.bool,
};

MoveToDialog.defaultProps = {
  show: false,
  name: '',
  projectDependency: {
    hasHighlightReelDependency: false,
    hasTagHighlightDependency: false,
    folder: {
      id: '',
    },
  },
  folder: {
    id: '',
  },
  errorMoveTo: false,
};

const mapStateToProps = ({ authentication }) => ({
  companyId: authentication.company?.id,
});

export default connect(mapStateToProps, null)(MoveToDialog);
